import React, { FC } from 'react';
import { BoxV2 as Box, Flex } from 'portal-commons';

import { Section, SectionTitle } from './atoms';
import { CampaignDetail } from '@/apis/core';

interface SampleMessagesSectionProps {
  campaign: CampaignDetail;
}

export const SampleMessagesSection: FC<SampleMessagesSectionProps> = ({
  campaign,
}) => {
  const samples = ['sample1', 'sample2', 'sample3', 'sample4', 'sample5']
    .map((key) => (campaign as unknown as Record<string, unknown>)[key])
    .filter(Boolean);

  return (
    <Section>
      <SectionTitle>Sample Messages</SectionTitle>
      <Flex as="ol" sx={{ flexDirection: 'column', gap: 'm', pl: '20px' }}>
        {samples.map((sample, index) => (
          <Box as="li" key={index} sx={{ fontSize: 'H300', color: '#313129' }}>
            {sample}
          </Box>
        ))}
      </Flex>
    </Section>
  );
};

export default SampleMessagesSection;
